var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invision"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M136.402 0H13.5979C6.08789 0 0 6.08789 0 13.5979V136.402C0 143.912 6.08789 150 13.5979 150H136.402C143.912 150 150 143.912 150 136.402V13.5979C150 6.08789 143.912 0 136.402 0Z",
    fill: "#DC395F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M50.1299 47.1946C55.1162 47.1946 59.2934 43.2864 59.2934 38.1641C59.2934 33.0453 55.1162 29.1377 50.1299 29.1377C45.1436 29.1377 40.9676 33.0453 40.9676 38.1641C40.9676 43.2858 45.1436 47.1946 50.1299 47.1946ZM31.1303 95.5462C30.5918 97.8373 30.3217 100.311 30.3217 102.329C30.3217 110.281 34.6336 115.56 43.7971 115.56C51.3967 115.56 57.5578 111.047 61.9939 103.759L59.2852 114.63H74.376L83.001 80.037C85.1572 71.2784 89.3344 66.7321 95.6684 66.7321C100.654 66.7321 103.753 69.8329 103.753 74.9517C103.753 76.4347 103.618 78.0501 103.079 79.8026L98.632 95.7033C97.9582 97.9943 97.6898 100.286 97.6898 102.441C97.6898 109.99 102.135 115.511 111.434 115.511C119.384 115.511 125.717 110.393 129.221 98.1296L123.292 95.841C120.328 104.056 117.767 105.542 115.746 105.542C113.724 105.542 112.646 104.195 112.646 101.502C112.646 100.289 112.917 98.9429 113.32 97.3222L117.633 81.8312C118.71 78.1937 119.115 74.9681 119.115 72.0044C119.115 60.4157 112.107 54.3676 103.618 54.3676C95.6684 54.3676 87.5824 61.5389 83.5406 69.0864L86.5043 55.5395H63.4629L60.2285 67.4716H71.0092L64.3705 94.0498C59.1574 105.638 49.5814 105.827 48.3797 105.558C46.4063 105.112 45.1441 104.363 45.1441 101.799C45.1441 100.319 45.4137 98.1941 46.0875 95.6318L56.1949 55.5395H30.5918L27.3574 67.4716H38.0022L31.1309 95.5462",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvision);
export default __webpack_public_path__ + "static/media/invision.5183ee04755c8934f0aed86201a43627.svg";
export { ForwardRef as ReactComponent };